// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-pill_d7e8eb88 {
  cursor: pointer;
  font-size: 1rem;
  height: 2.334rem;
  background-color: #fff;
  border-color: #11304d;
  --button-color: #11304d;
  --button-color-hover: #11304d;
  --button-color-active: #11304d;
  margin: 0 0.667rem 0.667rem 0;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  line-height: 1.5rem;
  border: solid 0.084rem #11304d;
  border-radius: 0.167em;
  padding: 0 0.667rem;
  font-weight: 600;
  transition: all 300ms ease;
  transition-property: background-color, border-color, color;
  max-width: 100%;
  position: relative;
}
.filter-pill_d7e8eb88:last-child {
  margin-right: 0;
}
.filter-pill_d7e8eb88 .button__icon:not(.button__icon_right) {
  min-width: auto;
  margin-right: 0.334rem;
}
.filter-pill_d7e8eb88 .button__icon_right {
  margin-left: 0.334rem;
  margin-right: 0;
}
.filter-pill__count_d7e8eb88 {
  padding-left: 0.292rem;
  font-weight: 400;
}
.filter-pill__name_d7e8eb88 {
  vertical-align: top;
}
.filter-pill_selected_d7e8eb88 {
  --button-color: #fff;
  --button-color-hover: #fff;
  --button-color-active: #fff;
  background-color: #11304d;
  border-color: #11304d;
}
.filter-pill_d7e8eb88:disabled {
  cursor: default;
  background-color: #eaedef;
  border: solid 0.084rem #c1c8cd;
  color: #c1c8cd;
}
.filter-pill_d7e8eb88:active:not(:disabled) {
  background-color: #a3adb4 !important;
}
.filter-pill_d7e8eb88:active:not(:disabled).filter-pill_selected_d7e8eb88 {
  background-color: #11304d !important;
  border-color: #051c38 !important;
}
.filter-pill_d7e8eb88:hover:not(:disabled) {
  background-color: #d3d5e0;
}
.filter-pill_d7e8eb88:hover:not(:disabled).filter-pill_selected_d7e8eb88 {
  background-color: #051c38;
  border-color: #051c38;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter-pill": `filter-pill_d7e8eb88`,
	"filter-pill__count": `filter-pill__count_d7e8eb88`,
	"filter-pill__name": `filter-pill__name_d7e8eb88`,
	"filter-pill_selected": `filter-pill_selected_d7e8eb88`
};
export default ___CSS_LOADER_EXPORT___;
